import { useEffect } from "react";
import { OrderDetailsViewModel } from "../../viewmodels/orders/OrderDetailsViewModel";

import { useParams } from "react-router-dom";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import OrderDetailsForm from "../../components/forms/orders/OrderDetailsForm";
import MobileOrderDetailsForm from "../../components/forms/orders/MobileOrderDetailsForm";

function OrderDetails(props) {
  const { logout } = props;

  const { orderId } = useParams();

  const {
    customers,
    getCustomersForDropdown,
    getMyProducts,
    loading,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    emptyModal,
    showErrorModal,
    updateOrderApiCall,
    order,
    getOrderDetails,
    onUpdateOrderItem,
    deleteOrderItemApiCall,
    addProductToOrderApiCall,
    employeeOptions,
    getUsersForDropdown,
    printOrder,
    createEstimate,
    askDeleteOrder,
    downloadEstimate,
    getOrderTotalsOnly,
  } = OrderDetailsViewModel(orderId, logout);

  const apiFunctionCalls = async function () {
    getOrderDetails();
    getCustomersForDropdown();
    getUsersForDropdown();
  };

  useEffect(() => {
    apiFunctionCalls();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="max-w-full m-6 bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-full mx-auto p-6">
          <div className="px-4">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
              <div className="flex-1">
                <h1 className="text-2xl font-bold text-gray-900 tracking-tight">
                  {order ? `${order.po_number}` : 'Order Details'}
                </h1>
              </div>
              
              {/* Action Buttons */}
              {order && (
                <div className="flex flex-col sm:flex-row gap-3">
                  <button
                    onClick={() => {
                      // Trigger save action - we'll handle this through the form component
                      window.dispatchEvent(new CustomEvent('saveOrder'));
                    }}
                    className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
                  >
                    Save
                  </button>
                  {printOrder && (
                    <button
                      onClick={printOrder}
                      className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
                    >
                      <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                      </svg>
                      Print
                    </button>
                  )}
                  {order.quickbooks_estimate_id > 0 ? (
            <button
              type="submit"
              className="inline-flex justify-center rounded-md bg-green-600 px-2 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={downloadEstimate}
            >
              Download QB Estimate
            </button>
          ) : (
            <button
              type="submit"
              className="inline-flex justify-center rounded-md bg-green-600 px-2 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={() => createEstimate()}
            >
              Estimate to QB
            </button>
          )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-full mx-auto px-6 pt-3 pb-6">
          {order ? (
            <div className="gap-6">
              {/* Main Content Column */}

              <div className="hidden md:block">
                <OrderDetailsForm
                  customers={customers}
                  getMyProducts={getMyProducts}
                  isEdit={true}
                  loading={loading}
                  order={order}
                  setEmptyModelOpen={setEmptyModelOpen}
                  showErrorModal={showErrorModal}
                  updateOrderApiCall={updateOrderApiCall}
                  onUpdateOrderItem={onUpdateOrderItem}
                  deleteOrderItemApiCall={deleteOrderItemApiCall}
                  addProductToOrderApiCall={addProductToOrderApiCall}
                  employeeOptions={employeeOptions}
                  createEstimate={createEstimate}
                  downloadEstimate={downloadEstimate}
                  getOrderTotalsOnly={getOrderTotalsOnly}
                />
              </div>
              <div className="md:hidden">
                <MobileOrderDetailsForm
                  getMyProducts={getMyProducts}
                  isEdit={true}
                  order={order}
                  setEmptyModelOpen={setEmptyModelOpen}
                  showErrorModal={showErrorModal}
                  updateOrderApiCall={updateOrderApiCall}
                  deleteOrderItemApiCall={deleteOrderItemApiCall}
                  addProductToOrderApiCall={addProductToOrderApiCall}
                  askDeleteOrder={askDeleteOrder}
                />
              </div>
            </div>
        ) : (
          <div className="px-4">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
              {/* Loading State */}
              <div className="flex items-center justify-center">
                <div className="flex flex-col items-center">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mb-4"></div>
                  <p className="text-gray-500">Loading order details...</p>
                </div>
              </div>
            </div>
        </div>
        )}
      </div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass="max-w-3xl"
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderDetails)
);
